import React, { FC, useCallback } from 'react';

import { FormControl, FormErrorMessage, Text, VStack } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

import Input from '@/components/Forms/Input';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/elements';

const LoginForm: FC<{ onSubmit?: () => void }> = ({
  onSubmit: onSubmitProp,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({ mode: 'onChange' });

  const { signIn, signInError, isSigningIn } = useAuth();

  const onSubmit = useCallback(async (values) => {
    if (values.email && values.password) {
      const success = await signIn(values.email, values.password);

      if (success && onSubmitProp) {
        onSubmitProp();
      }
    }
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <VStack spacing='md'>
        <FormControl isInvalid={errors.email}>
          <Input
            control={control}
            label='Your email'
            name='email'
            rules={{ required: 'This field is required' }}
            type='email'
          />
          {errors.email && (
            <FormErrorMessage>{errors.email.message}</FormErrorMessage>
          )}
        </FormControl>
        <FormControl isInvalid={errors.password}>
          <Input
            control={control}
            label='Your password'
            name='password'
            rules={{ required: 'This field is required' }}
            type='password'
          />
          {errors.password && (
            <FormErrorMessage>{errors.password.message}</FormErrorMessage>
          )}
        </FormControl>
      </VStack>

      {signInError && (
        <Text color='red' mt='2'>
          {signInError}
        </Text>
      )}

      <Button
        data-cy='signInButton'
        isDisabled={!isValid}
        isLoading={isSigningIn}
        minWidth={200}
        mt='xl'
        type='submit'
        w='100%'
      >
        Sign In
      </Button>
    </form>
  );
};

export default LoginForm;
